<template>
    <ai-nav :isEnterprise="industryChat == 1 ? true : false">
        <template>
            <div class="ai-chat-page">
                <div class="chat-container">
                    <div class="pl-1 font-18">{{ pageTitle }}</div>
                    <div class="messages">
                        <div v-for="(mesg, index) in messages" :key="index"
                            :class="[mesg.sender == 'AI' ? 'message-left my-1' : 'message-right message']">
                            <!-- 用户消息 and AI消息-->
                            <div class="typewriter markdown-body" v-if="mesg.message !== 'thinking'"
                                v-html="mesg.message"></div>

                            <!-- 思考中... -->
                            <div v-if="mesg.message === 'thinking'" class="thinking">
                                <i class="el-icon-loading mr-1"></i>
                                <span>Deepseek正在思考中，请您稍等……</span>
                            </div>
                            <div class="mt-1" v-if="mesg.sender === 'AI' && index == 1 && mesg.message === 'thinking'">
                                本次研究任务预计需要花费2-3分钟。分析研究支持后台运行，您可以先去处理别的事情，3分钟后再来查看结果。</div>
                            <div class="mt-1" v-if="mesg.sender === 'AI' && mesg.message != 'thinking'">
                                注：本回答由 AI 自动生成，内容仅供参考。</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ai-nav>

</template>
<script>

import aiNav from '../inc/aiNav.vue';
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt();
export default {
    components: { aiNav },
    data() {
        return {
            userdata: {},
            messages: [
                // {sender: "AI", message: "Hi，我是 中投产业专家～很高兴遇见你！"}

            ],
            userInput: { sender: "user", message: "" },
            historyList: [
                { sender: "user", message: "比亚迪股份有限公司拿地数据和投资趋势分析" },
                { sender: "user", message: "宁德时代股份有限公司拿地数据和投资趋势分析" },
            ],
            type: 1, //1土地，2专利，3研发
            model: 1, //1: v3 2: R1
            id: 1,
            isUserScrolling: false, // 标志用户是否正在手动滚动
            pageTitle: '',
            isUpdate: 0, //是否需要更新历史记录数据，0不更新，1更新
        };
    },
    watch: {
        $route: function (newVal, oldVal) {
            console.log('watch');
            if (newVal.query.id !== oldVal.query.id) {
                this.id = newVal.query.id;
                // alert('历史记录');
                this.type = newVal.query.type;
                this.id = newVal.query.id;

                //清空当前数据，避免多条数据累加
                this.messages = [];
                this.getChat();
            }
        }
    },
    created() {
        this.userdata = this.getuseriformation();
        console.log(this.userdata);
        this.type = this.$route.query.type;
        this.model = this.$route.query.model;
        this.id = this.$route.query.id;
        this.industryChat = this.$route.query.industryChat; //用来判断是否是行业分析
        this.isUpdate = this.$route.query.update; //用来判断是否需要更新历史记录数据
    },
    mounted() {
        if (this.industryChat == 1 && this.type != 'history') {
            this.getAssessmentEnterprise();
        } else {
            this.getChat();
        }
    },
    methods: {
        //企业详情页行业分析接口
        getAssessmentEnterprise() {
            let aiChatData = JSON.parse(localStorage.getItem('aiChatData'));
            let that = this;
            let id = this.splicing('stockCode', this.$route.query.id); //市场规模和竞争格局id
            let notionCode = this.splicing('notionCode', this.$route.query.notionCode); //行业code
            let type = this.splicing('type', this.$route.query.type); //分析类型
            let isUpdate = this.splicing('update', this.isUpdate);
            let ajaxUrl = this.$api.cyl.assessment.enterprise() + "?model=" + this.model + type + id + notionCode+isUpdate;
            console.log(ajaxUrl);
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            document.title = aiChatData.title;
            // 发送请求
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log(res);
                    let fullMessage = '';
                    if (that.$route.query.industryChat) { //如果是企业库历史记录，需要展示很多端内容

                        // 收集所有 markdown 片段
                        const sections = [
                            res.data.data.industryMarket,
                            res.data.data.industryMarket1,
                            res.data.data.industryMarket2,
                            res.data.data.industryMarket3,
                            res.data.data.industryTrend,
                            res.data.data.companyStrength,
                            res.data.data.companyCompete,
                            res.data.data.companyRisk,
                            res.data.data.industryMatch,
                            res.data.data.fundingPolicy,
                            res.data.data.comprehensive
                        ].filter(item => item && item.trim()); // 过滤空值

                        // 拼接后用 md.render 统一渲染
                        const markdownContent = sections.join('\n\n');
                        fullMessage = md.render(markdownContent);

                    }
                    that.messages.pop();
                    that.messages.push({ sender: "AI", message: fullMessage });

                } else {
                    that.messages.push({ sender: "AI", message: res.data.msg || '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });

        },
        //行研智能体分析
        getIndutryChat() {


            let aiChatData = JSON.parse(localStorage.getItem('aiChatData'));
            let that = this;
            let type = this.type;
            let id = this.splicing('id', this.$route.query.id); //市场规模和竞争格局id
            let ajaxUrl = this.$api.common.analyse.chatDetail() + "?type=" + type + id;
            console.log(ajaxUrl);
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            document.title = aiChatData.title;
            // 发送请求
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log(res);
                    let thinkingProcess = '', result = '';
                    // if (that.type != 'history') { //如果不是历史记录要更新栏目历史记录数据
                    //     // 添加这行触发事件
                    //     that.bus.$emit('aiHistory-updated');
                    // }

                    // if (res.data.data.outputR1 && res.data.data.outputR1 !== '') {
                    //     // 如果 model == 2，拼接思考过程和结果
                    //     thinkingProcess = res.data.data.outputR1Chain; // 假设后端返回的思考过程字段为 outputR1Chain
                    //     result = res.data.data.outputR1; // 假设后端返回的结果字段为 outputR1
                    // } else {
                    //     // 其他情况只展示结果
                    //     result = res.data.data.outputV3; // 假设后端返回的结果字段为 outputV3
                    // }
                    // // 拼接思考过程和结果
                    // let fullMessage = '';
                    // if (that.model == 2 && thinkingProcess) {
                    //     fullMessage = `<div class="thinking-process">\n${thinkingProcess}</div><div class="result">${result}</div>`;
                    // } else {
                    //     fullMessage = `\n${result}`;
                    // }
                    // 移除“思考中...”并展示完整消息
                    // if(that.type == 'history'){
                    //     逐字展示完整内容
                    // that.typeAnswer(fullMessage);
                    //     that.typeText({ sender: "AI", message: fullMessage }, 0);
                    // }else{
                    that.messages.pop();
                    that.messages.push({ sender: "AI", message: res.data.data.content });
                    // }
                    // that.$nextTick(() => {
                    //     // 删除只有句号的<p>
                    //     document.querySelectorAll('p').forEach(p => {
                    //         console.log(p);
                    //         if (p.textContent.trim() === '。') {
                    //             p.remove(); // 直接删除
                    //             // 或者改为行内元素：
                    //             // p.style.display = 'inline';
                    //         }
                    //     });
                    // })

                } else {
                    that.messages.push({ sender: "AI", message: res.data.msg || '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        //行业数据库和企业详情数据分析
        getChat() {

            let ajaxUrl = '';
            let aiChatData = JSON.parse(localStorage.getItem('aiChatData'));
            let that = this;
            let stockCode = this.id;
            let model = this.model;
            let type = this.type;
            let marketId = this.splicing('id', this.$route.query.id); //市场规模和竞争格局id
            let code = this.splicing('code', this.$route.query.code);
            if (type == 4 || type == 5 || type == 6) { //4:市场规模 5:竞争格局 6:产品产量及其他
                ajaxUrl = this.$api.cyl.deepseek.market() + "?model=" + model + "&type=" + type + code + marketId;
            } else if (type == 1 || type == 2 || type == 3) { //1:企业 2:研发 3:专利
                ajaxUrl = this.$api.cyl.deepseek.enterprise() + "?stockCode=" + stockCode + "&model=" + model + "&type=" + type;
            } else if (type == 'history') {
                if (this.$route.query.isEnterprise) {
                    ajaxUrl = this.$api.cyl.assessment.detail() + '?id=' + this.id; //企业库历史记录
                } else {
                    ajaxUrl = this.$api.cyl.deepseek.detail() + '?id=' + this.id; //历史记录
                }

            }

            console.log(ajaxUrl);
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            document.title = aiChatData.title;
            // 发送请求
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log(res);
                    let thinkingProcess = '', result = '';
                    if (that.type != 'history') { //如果不是历史记录要更新栏目历史记录数据
                        // 添加这行触发事件
                        that.bus.$emit('aiHistory-updated');
                    }

                    if (res.data.data.outputR1 && res.data.data.outputR1 !== '') {
                        // 如果 model == 2，拼接思考过程和结果
                        thinkingProcess = res.data.data.outputR1Chain; // 假设后端返回的思考过程字段为 outputR1Chain
                        result = res.data.data.outputR1; // 假设后端返回的结果字段为 outputR1
                    } else {
                        // 其他情况只展示结果
                        result = res.data.data.outputV3; // 假设后端返回的结果字段为 outputV3
                    }
                    // 拼接思考过程和结果
                    let fullMessage = '';
                    if (that.model == 2 && thinkingProcess) {
                        fullMessage = `<div class="thinking-process">\n${thinkingProcess}</div><div class="result">${result}</div>`;
                    } else {
                        fullMessage = `\n${result}`;
                    }
                    if (that.type == 'history' && that.$route.query.isEnterprise) {

                        // 收集所有 markdown 片段
                        const sections = [
                            res.data.data.industryMarket,
                            res.data.data.industryMarket1,
                            res.data.data.industryMarket2,
                            res.data.data.industryMarket3,
                            res.data.data.industryTrend,
                            res.data.data.companyStrength,
                            res.data.data.companyCompete,
                            res.data.data.companyRisk,
                            res.data.data.industryMatch,
                            res.data.data.fundingPolicy,
                            res.data.data.comprehensive
                        ].filter(item => item && item.trim()); // 过滤空值

                        // 拼接后用 md.render 统一渲染
                        const markdownContent = sections.join('\n\n');
                        fullMessage = md.render(markdownContent);
                    }
                    that.messages.pop();
                    that.messages.push({ sender: "AI", message: fullMessage });
                    // }


                } else {
                    that.messages.push({ sender: "AI", message: res.data.msg || '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        typeText(message, index) {
            if (index < message.message.length) {
                message.displayMessage += message.message.charAt(index);
                requestAnimationFrame(() => {
                    this.typeText(message, index + 1);
                });
            }
        },
        typeAnswer(answer, callback, isResult = false) {
            let i = 0;
            const timer = setInterval(() => {
                if (i < answer.length) {
                    this.displayedText.push(answer[i]);
                    i++;
                } else {
                    clearInterval(timer);
                }
            }, 100);
        },
        scrollToCenter() {
            const container = this.$el.querySelector(".messages");
            const chatContainer = this.$el.querySelector(".chat-container");
            console.log(container, chatContainer);
            if (container && chatContainer) {
                const containerHeight = container.scrollHeight;
                const chatHeight = chatContainer.clientHeight;

                // 计算滚动位置，让内容保持在正中间
                const scrollTop = (containerHeight - chatHeight) / 2;
                chatContainer.scrollTop = scrollTop > 0 ? scrollTop : 0;
            }
        },
    },
};
</script>

<style lang="scss">
.markdown-body h3 {
    font-size: 18px;
    font-weight: bold;
    margin: 16px 0 8px;
}

.markdown-body p {
    line-height: 1.6;
    margin: 8px 0;
}

.markdown-body strong {
    font-weight: bold;
}

.typewriter {
    //首行缩进
    text-indent: 2em;

    p span[style*="font-size: 10px"] {
        /* 匹配含特定样式的 span */
        display: none !important;
    }

    p:has(> :empty:last-child) {
        /* 匹配内容为空的<p> */
        display: inline;
    }

    p,
    h1,
    h2,
    h4,
    h3,
    h5,
    ul,
    ol,
    li,
    span {
        background: rgba(0, 0, 0, 0) !important;
    }

    table {
        width: 100%;
        border: 1px solid #E0E0E0 !important;
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0 auto;
    }

    hr {
        border-top: 1px solid #999 !important;
        margin-top: 25px;
    }

}

.ai-chat-page {
    width: 100%;
}

.chat-container {
    // width: 100%;
    // max-width: 1200px;
    // height: 90%;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 90vh;
    height: calc(100vh - 40px);
    overflow-y: auto;

}

.messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // justify-content: center; /* 垂直居中 */
    align-items: center;
    /* 水平居中 */
    // text-align: center; /* 文本居中 */
    width: 80%;
    margin: 0 auto;
}

.message {
    // max-width: 100%;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 2;
    word-wrap: break-word;
}

.message-left {
    align-self: flex-start;
    // background-color: #e5e7ed;
    color: #333;
    border-top-left-radius: 0;
}


.message-right {
    align-self: flex-end;
    background-color: #37a3ff;
    color: #fff;
    border-top-right-radius: 0;
}

.thinking {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    font-style: italic;
    background-color: #e5e7ed;
    border-radius: 15px;
    border-top-left-radius: 0;
    padding-left: 20px;
    line-height: 40px;
    padding: 10px 15px;
}

.el-icon-loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.meun-box {
    position: fixed;
    bottom: 50%;
    left: 20px;
    padding: 3px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;

    .item:hover {
        background-color: #eee;
        border-radius: 10px;
    }

    span {
        padding: 7px;
        cursor: pointer;
        display: inline-block;
    }
}

.history-container {
    padding: 10px;
    width: 1200px;
    height: 90vh;

    .history-date {
        padding: 10px;
        border-radius: 10px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        color: #666;
        background-color: #fff;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover {
            box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;
        }
    }
}
</style>